export default "__VITE_ASSET__h0G08Ky3__"